import { ReactElement } from "react";
import { DebouncedInput } from "@altimateai/lego";
import { IconSearch } from "@tabler/icons-react";

export interface DataMatesSearchProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
}

export function DataMatesSearch({
  searchQuery,
  onSearchChange,
}: DataMatesSearchProps): ReactElement {
  return (
    <DebouncedInput
      icon={IconSearch}
      placeholder="Search by name"
      debounceMs={300}
      className="al-w-full"
      value={searchQuery}
      onChange={onSearchChange}
      aria-label="Search datamates by name"
    />
  );
}
